import React, { Dispatch, FC, ReactNode, SetStateAction, useContext } from 'react'
import { WHITE } from '../../theme'
import { ResponsiveContext } from '../../utils/context/ResponsiveContext'
import { makeStyles } from 'tss-react/mui'
import { ClickAwayListener } from '@mui/material'
import { styled } from '@mui/material/styles'
import MuiTooltip, { tooltipClasses, TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip'

const tooltipPopperStyle = {
	top: '-10px !important',
	left: '-40px !important',
	pointerEvents: 'initial'
}

const useStyles = makeStyles<{ open: boolean }>()(
	(theme, { open }) => (
		{
			tooltipContainer: {
				position: 'absolute',
				zIndex: open ? 2000 : 1
			}
		}
	)
)

const CustomTooltip = styled(({ className, ...props }: MuiTooltipProps) => (
	<MuiTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		background: WHITE,
		color: theme.palette.blue.main,
		border: `1px solid ${theme.palette.blue.main}`,
		borderRadius: 10,
		paddingLeft: 25,
		paddingTop: 25
	},
	[`& .${tooltipClasses.tooltipPlacementBottom}`]: {
		marginTop: -25,
		paddingTop: 30
	}
}))

interface AcceptingProps {
	title: string | ReactNode,
	open: boolean,
	setOpen: Dispatch<SetStateAction<boolean>>,
	tooltipContainerStyle?: string
	children: ReactNode
}

type TooltipProps = AcceptingProps

const Tooltip: FC<TooltipProps> = (
	{
		title,
		children,
		open,
		setOpen,
		tooltipContainerStyle
	}
) => {
	const { classes, cx } = useStyles({ open })
	const { isLargeScreen } = useContext(ResponsiveContext)

	return (
		<ClickAwayListener onClickAway={() => setOpen(false)}>
			<CustomTooltip
				title={title as string}
				onClick={() => setOpen((prevState: boolean) => !prevState)}
				placement={isLargeScreen ? 'right-start' : 'bottom'}
				open={open}
				PopperProps={{
					disablePortal: true,
					sx: tooltipPopperStyle
				}}
			>
				{React.createElement('span', { className: cx(classes.tooltipContainer, tooltipContainerStyle) }, children)}
			</CustomTooltip>
		</ClickAwayListener>
	)
}

export default Tooltip